/**
 * Survey announcement content — the single source of truth for the copy and
 * link rendered by AnnouncementDialog.
 */

export const SURVEY_URL = 'https://cc.exante.eu/a/cc-survey/s/s_Hie8RvbEw940nzaa'

/**
 * Announcement copy: capture a 1–5 star rating inline first, then (after
 * rating) invite the user to the full survey. Higher response rate than a pure
 * link-out because the cheap signal is one tap.
 */
export const npsAnnouncementContent = {
  eyebrow: 'Code Concierge User Survey',
  headline: 'How are we doing?',
  body: 'Tap to rate your experience with the Code Concierge platform so far.',
  /** Shown under the stars before a rating is given. */
  ratePrompt: 'Tap a star to rate',
  /** Headline shown after the user picks a rating. */
  thanksHeadline: 'Thanks for the feedback!',
  /** Body shown after rating, inviting the longer survey. */
  thanksBody: "If you have around 2 minutes, we'd love a little more detail.",
  /** CTA to the full survey (shown after rating). */
  ctaLabel: 'Take the full survey',
  /** Soft defer — snoozes for ~a week (capped). */
  deferLabel: 'Maybe later',
  /** Terminal opt-out for this round — "I already did it / not interested". */
  doneLabel: "I've done it",
} as const
